import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../_App/Redux/hooks";
import { TicketsTechsStats } from "../../_App/Redux/Slices/tickets/ticketSlice";
import { Form, Button } from "react-bootstrap";
import * as XLSX from "xlsx";

const TechniciensTicketsStatsTable = () => {
  const stats = useAppSelector(TicketsTechsStats);
  const dispatch = useAppDispatch();

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;
  const [searchTerm, setSearchTerm] = useState("");

  // 1. Fixed Search Filter to match new API keys
  const filteredData = stats.filter(
    (item: any) =>
      item.technician_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.technician_code?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const handlePageChange = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  // 2. Fixed Excel Export keys
  const exportToExcel = () => {
    const dataToExport = filteredData.map((item: any) => ({
      Code: item.technician_code,
      Technicien: item.technician_name,
      "Tickets Assignés (Shift)": item.tickets_assigned_during_shift,
      "Tickets Résolus": item.tickets_resolved,
    }));

    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Stats Techniciens");
    XLSX.writeFile(workbook, "Stats_Techniciens.xlsx");
  };

  return (
    <>
      <div
        className="row mb-3"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div className="col-10">
          <Form.Group controlId="formSearch">
            <Form.Control
              type="text"
              placeholder="Recherche par nom ou code technicien..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </Form.Group>
        </div>
        <div className="col-2">
          <Button
            variant="success"
            onClick={exportToExcel}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <i className="fas fa-file-excel mr-2"></i> Export
          </Button>
        </div>
      </div>

      <table id="style-3" className="table style-3 table-hover">
        <thead>
          <tr>
            <th>Technicien</th>
            <th className="text-center">Tickets Assignés</th>
            <th className="text-center">Tickets clôturés</th>
          </tr>
        </thead>
        <tbody>
          {currentItems.length > 0 ? (
            currentItems.map((item: any, index: any) => (
              <tr key={item.technician_code || index}>
                
                <td>
                  <span className="font-weight-bold">
                    {item.technician_name}
                  </span>
                </td>
                <td className="text-center">
                  <span
                    className="badge badge-info"
                    style={{ fontSize: "14px" }}
                  >
                    {item.tickets_assigned_during_shift}
                  </span>
                </td>
                <td className="text-center">
                  <span
                    className="badge badge-success"
                    style={{ fontSize: "14px" }}
                  >
                    {item.tickets_resolved}
                  </span>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={4} className="text-center">
                Aucune donnée disponible
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {totalPages > 1 && (
        <div className="pagination" style={{ overflow: "auto", margin: "5px" }}>
          <button
            disabled={currentPage === 1}
            onClick={() => handlePageChange(currentPage - 1)}
            className="btn"
          >
            Préc.
          </button>
          {Array.from({ length: totalPages }, (_, i) => (
            <button
              key={i + 1}
              className={currentPage === i + 1 ? "btn active" : "btn"}
              onClick={() => handlePageChange(i + 1)}
            >
              {i + 1}
            </button>
          ))}
          <button
            disabled={currentPage === totalPages}
            onClick={() => handlePageChange(currentPage + 1)}
            className="btn"
          >
            Suiv.
          </button>
        </div>
      )}
    </>
  );
};

export default TechniciensTicketsStatsTable;